/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicUserPermissionAssignmentDto } from './PublicUserPermissionAssignmentDto';
import type { PublicUserTeamDto } from './PublicUserTeamDto';

export type PublicUserGetDto = {
    /**
     * Authorized authentication type of the user
     */
    authTypes: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    /**
     * Email of the user
     */
    email: string;
    id: string;
    /**
     * Name of the user
     */
    name: string;
    /**
     * Domain access permissions of the user
     */
    permissions: Array<PublicUserPermissionAssignmentDto>;
    /**
     * System role of the user
     */
    role: PublicUserGetDto.role;
    /**
     * Status of the user
     */
    status: PublicUserGetDto.status;
    /**
     * Teams of the user
     */
    teams: Array<PublicUserTeamDto>;
};

export namespace PublicUserGetDto {

    /**
     * System role of the user
     */
    export enum role {
        ADMIN = 'ADMIN',
        EDITOR = 'EDITOR',
        VIEWER = 'VIEWER',
    }

    /**
     * Status of the user
     */
    export enum status {
        ENABLED = 'ENABLED',
        DISABLED = 'DISABLED',
    }


}
